export default {
  showVerification: false, // 查询本人车票，是否要拉起人脸核验
  tickets12306List: [],
  passengerInfo: {},
  photos12306: undefined, // 人脸核验的照片
  tickets12306NeedCheck: false,
  totalPage: 0
}